// extracted by mini-css-extract-plugin
module.exports = {"album":"album_album__YZQos","albumInfo":"album_albumInfo__yNfza","audioIcon":"album_audioIcon__VjVyS","albumHover":"album_albumHover__DkqYu"};